import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { DASHBOARD_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const LOAD_DAY_STAT = '_LOAD_DAY_STAT';
export const LOAD_LAST_SESSION = '_LOAD_LAST_SESSION';
export const LOAD_CONFIGURED_VIOLATIONS = '_LOAD_CONFIGURED_VIOLATIONS';
export const LOAD_EXPORT_STATUS = '_LOAD_EXPORT_STATUS';
export const GET_CAMERA_STREAM = '_GET_CAMERA_STREAM';
export const CREATE_SCREENSHOT = '_CREATE_SCREENSHOT';
export const ALL_NODE_EVENT = '_ALL_NODE_EVENT';
export const LOAD_NODE_STATE = '_LOAD_NODE_STATE';

export const loadDayStat = createDeferredAction(DASHBOARD_MODULE + LOAD_DAY_STAT);
export const loadDayStatSuccessful = createAction(DASHBOARD_MODULE + LOAD_DAY_STAT + SUCCESSFUL);
export const loadDayStatFailed = createAction(DASHBOARD_MODULE + LOAD_DAY_STAT + FAILED);

export const loadLastSession = createDeferredAction(DASHBOARD_MODULE + LOAD_LAST_SESSION);
export const loadLastSessionSuccessful = createAction(DASHBOARD_MODULE + LOAD_LAST_SESSION + SUCCESSFUL);
export const loadLastSessionFailed = createAction(DASHBOARD_MODULE + LOAD_LAST_SESSION + FAILED);

export const loadConfiguredViolations = createDeferredAction(DASHBOARD_MODULE + LOAD_CONFIGURED_VIOLATIONS);
export const loadConfiguredViolationsSuccessful = createAction(DASHBOARD_MODULE + LOAD_CONFIGURED_VIOLATIONS + SUCCESSFUL);
export const loadConfiguredViolationsFailed = createAction(DASHBOARD_MODULE + LOAD_CONFIGURED_VIOLATIONS + FAILED);

export const loadExportStatus = createDeferredAction(DASHBOARD_MODULE + LOAD_EXPORT_STATUS);
export const loadExportStatusSuccessful = createAction(DASHBOARD_MODULE + LOAD_EXPORT_STATUS + SUCCESSFUL);
export const loadExportStatusFailed = createAction(DASHBOARD_MODULE + LOAD_EXPORT_STATUS + FAILED);

export const getCameraStream = createDeferredAction(DASHBOARD_MODULE + GET_CAMERA_STREAM);
export const getCameraStreamSuccessful = createAction(DASHBOARD_MODULE + GET_CAMERA_STREAM + SUCCESSFUL);
export const getCameraStreamFailed = createAction(DASHBOARD_MODULE + GET_CAMERA_STREAM + FAILED);

export const createScreenshot = createDeferredAction(DASHBOARD_MODULE + CREATE_SCREENSHOT);
export const createScreenshotSuccessful = createAction(DASHBOARD_MODULE + CREATE_SCREENSHOT + SUCCESSFUL);
export const createScreenshotFailed = createAction(DASHBOARD_MODULE + CREATE_SCREENSHOT + FAILED);

export const allNodeEvent = createDeferredAction(DASHBOARD_MODULE + ALL_NODE_EVENT);
export const allNodeEventSuccessful = createAction(DASHBOARD_MODULE + ALL_NODE_EVENT + SUCCESSFUL);
export const allNodeEventFailed = createAction(DASHBOARD_MODULE + ALL_NODE_EVENT + FAILED);

export const loadNodeState = createDeferredAction(DASHBOARD_MODULE + LOAD_NODE_STATE);
export const loadNodeStateSuccessful = createAction(DASHBOARD_MODULE + LOAD_NODE_STATE + SUCCESSFUL);
export const loadNodeStateFailed = createAction(DASHBOARD_MODULE + LOAD_NODE_STATE + FAILED);
